const DETAIL_BUTTON_STYLE = {
  background: "none",
  border: 0,
  appearance: "none",
  font: "inherit",
  color: "inherit",
  textAlign: "inherit",
  cursor: "pointer",
} as const;

interface DetailActionCellProps {
  title: string;
  onClick: () => void;
}

export default function DetailActionCell({ title, onClick }: Readonly<DetailActionCellProps>) {
  return (
    <td className="table-action">
      <button
        type="button"
        className="rioglyph rioglyph-info-sign text-size-18 text-color-primary cursor-pointer"
        style={DETAIL_BUTTON_STYLE}
        tabIndex={0}
        onClick={(evento) => {
          evento.stopPropagation();
          onClick();
        }}
        onKeyDown={(evento) => {
          if (evento.key === "Enter" || evento.key === " ") {
            evento.preventDefault();
            evento.stopPropagation();
            onClick();
          }
        }}
        title={title}
      />
    </td>
  );
}
